import FilesReadyToPublish from '@/pages/publish/files'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/publish/files'
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <FilesReadyToPublish />
}
